export enum ListType {
	CUSTOM = 'CUSTOM',
	FAVORITES = 'FAVORITES',
	RECOMMENDED = 'RECOMMENDED',
	SAVEFORLATER = 'SAVEFORLATER'
}